import React, { useState } from 'react';
import { whatsappCoachingService } from '../services/whatsappCoachingService';
import { useLanguage } from '../contexts/LanguageContext';
import whatsappLogo from '../assets/whatsapp-premium.png';

const WHATSAPP_COACHING_TEXTS: Record<string, { error: string }> = {
  en: {
    error: 'Failed to start WhatsApp coaching',
  },
  nl: {
    error: 'Kan WhatsApp coaching niet starten',
  },
  ar: {
    error: 'فشل بدء تدريب واتس آب',
  },
};

export function WhatsAppCoachingCTA() {
  const { currentLanguage } = useLanguage();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const lang = (currentLanguage === 'nl' ? 'nl' : currentLanguage === 'ar' ? 'ar' : 'en') as keyof typeof WHATSAPP_COACHING_TEXTS;
  const texts = WHATSAPP_COACHING_TEXTS[lang] || WHATSAPP_COACHING_TEXTS.en;

  const handleStartCoaching = async () => {
    setLoading(true);
    setError(null);

    try {
      const result = await whatsappCoachingService.initWhatsAppCoaching(lang);
      // Open WhatsApp link
      window.open(result.whatsappLink, '_blank');
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : texts.error;
      setError(errorMessage);
      console.error('WhatsApp coaching error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="practice-whatsapp">
      <div className="practice-whatsapp-title">
        <img className="practice-whatsapp-title-icon" src={whatsappLogo} alt="" aria-hidden="true" />
        <span>Practice in WhatsApp</span>
      </div>
      {error && <p className="practice-whatsapp-error">{error}</p>}
      <button
        type="button"
        className="practice-whatsapp-cta"
        onClick={handleStartCoaching}
        disabled={loading}
      >
        Sign up
        <img className="practice-whatsapp-icon" src={whatsappLogo} alt="" aria-hidden="true" />
      </button>
    </div>
  );
}
